import differenceWith from "lodash/differenceWith";
import fromPairs from "lodash/fromPairs";
import isEqual from "lodash/isEqual";
import toPairs from "lodash/toPairs";

export function getJsonDifference<T extends object>(newObject: T, oldObject: T) {
	return fromPairs<T>(differenceWith(toPairs(newObject), toPairs(oldObject), isEqual));
}
